
import React from 'react';
import Radio from '@mui/material/Radio';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';

// ✅ Styled Radio using MUI v5
// const StyledRadio = styled(Radio)(({ theme }) => ({
//   color: grey[900],
//   '&.Mui-checked': {
//     color: '#00B0A9',
//   },
//   padding: '0px',
// }));

class RadioMaterialUI extends React.Component {
  state = {
    checkboxStatus: this.props.checkedStatus || false,
  };

  handleChange = (event) => {
    this.setState({ checkboxStatus: event.target.checked });
    this.props.changeHandler(event.target.checked);
  };

  render() {
    return (
      // <StyledRadio 
      //   checked={this.props.checkedStatus}
      //   onChange={this.handleChange}
      //   value="checkboxStatus"
      // />
      <input style={{
        zIndex:'100',
        cursor: "default",
        transform: 'scale(1.5)', // Adjust size here (e.g., 1.5x)
      }}
        type="radio"
        checked={this.props.checkedStatus}
        onChange={this.handleChange}
        // value="checkboxStatus"
      />
    );
  }
}

export default RadioMaterialUI;
